import React from 'react'
import './ErrorBoundary.css'

type State = { error: Error | null; componentStack: string }

export default class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null, componentStack: '' }

  static getDerivedStateFromError(error: Error): State {
    return { error, componentStack: '' }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    // Keep this console.error: it’s high-signal when the UI whitescreens.
    console.error('[UI] Uncaught error:', error, info)
    this.setState({ componentStack: info.componentStack || '' })
  }

  render() {
    if (this.state.error) {
      return (
        <div className="eb-wrap">
          <div className="eb-card">
            <div className="eb-title">Something went wrong</div>
            <div className="eb-subtitle">
              The UI hit an unexpected error. Refreshing usually resolves it; if it persists, we’ll fix the underlying cause.
            </div>
            <pre className="eb-error">{String(this.state.error.message || this.state.error)}</pre>
            {this.state.componentStack && (
              <pre className="eb-error eb-stack">{this.state.componentStack}</pre>
            )}
            <div className="eb-actions">
              <button className="btn-primary" type="button" onClick={() => window.location.reload()}>
                Refresh page
              </button>
            </div>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}


